import { render } from "./CatalogoSinPrecio.vue?vue&type=template&id=ad712026"
import script from "./CatalogoSinPrecio.vue?vue&type=script&lang=js"
export * from "./CatalogoSinPrecio.vue?vue&type=script&lang=js"

import "./CatalogoSinPrecio.vue?vue&type=style&index=0&id=ad712026&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__